// extracted by mini-css-extract-plugin
export default {"icon-picker-toolbar":"icon-picker-toolbar--MTb2k","icon-picker-tag":"icon-picker-tag--hKoz8"};